export const RELANCE_SEND_SET_ERROR = "RELANCE_SEND_SET_ERROR";
export const RELANCE_SEND_TOGGLE_LOADING = "RELANCE_SEND_TOGGLE_LOADING";
